export default {"src":"/_next/static/media/edit.faa72cb9.svg","height":14,"width":14};